import fetchSeo from "common/fetch/fetchSeo";

import Layout from "components/common/Layout";
import HongKongTool from "components/templates/hk/guide-and-tool/hong-kong-cost-planning-tool";

export default function Home({ data }) {
  return (
    <div>
      <Layout locationRouter="hk" page={data.page}>
        <HongKongTool data={data} />
      </Layout>
    </div>
  );
}

export const getStaticProps = async () => {
  const locale = "hk";
  const uri = "/guide-and-tool/hong-kong-cost-planning-tool";
  const page = await fetchSeo({
    uri,
    locale,
  });
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_WORDPRESS_HK}/wp-json/api/hk-cost-planning-tool`
  );
  const dataHkTool = await res.json();

  if (!dataHkTool) {
    return {
      notFound: true,
    };
  }
  const newData = {};

  newData.hongkongTool = dataHkTool;
  newData.page = page || {};

  return {
    props: {
      data: newData || {},
    },
  };
};
